import React from "react";
import "./stylesheet/cinemaHallButtonsStyle.css";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { ArrowBackOutline } from "react-ionicons/lib";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { useNavigate } from "react-router";
import { FINALIZE_PAGE } from "../../../routes";
import { useTranslation } from "react-i18next";

interface IProps {
  activeStep: number;
  setActiveStep: (value: number) => void;
  totalBasket: number;
  validateBasket: Function;
}

const colorIcon = "var(--primary-text)";

const CinemaHallButtons: React.FC<IProps> = ({ activeStep, setActiveStep, totalBasket, validateBasket }: IProps) => {
  const isDesktop = useDesktopSize();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const selectedSeats = useSelector((state: State) => state.basket.selectedSeats);
  const disabledSelectTicket = selectedSeats.length === 0;

  const handleNextBtn = () => {
    if (activeStep === 0) {
      setActiveStep(1);
    } else if (activeStep === 1) {
      navigate(FINALIZE_PAGE);
    }
  };

  return (
    <div className={`cinema-hall-buttons ${!isDesktop ? "mobile" : ""}`}>
      <button className={"button-summary"}>
        {activeStep === 1 ? (
          <div>
            <div>
              <ArrowBackOutline
                color={colorIcon}
                title={""}
                height="30px"
                width="30px"
                onClick={() => setActiveStep(0)}
              />
            </div>
            <div>
              <p>{t("razem")}:</p>
              <p>
                {totalBasket} {t("zl")}
              </p>
            </div>
          </div>
        ) : (
          <div>
            <p>{t("wybrane_miejsca")}: </p>
            <p>{selectedSeats.length}</p>
          </div>
        )}
      </button>
      <button
        className={"button-next-step"}
        disabled={activeStep === 1 ? validateBasket() : disabledSelectTicket}
        onClick={handleNextBtn}
      >
        {activeStep === 1 ? <p>{t("podsumowanie")}</p> : <p>{t("wybierz_bilety")}</p>}
      </button>
    </div>
  );
};

export default CinemaHallButtons;
